import React, { useContext, useEffect, useState } from 'react'
import './Popular.css'
import Item from '../Items/Item'
import { ShopContext } from '../../Context/ShopContext';
const Popular = () => {
  const [data_product,setdata_prodcut]=useState([]);
  const {url}=useContext(ShopContext);
  useEffect(()=>{
    const fetch_data=async()=>{
      try{
        await fetch(`${url}/popularwomen`)
    .then((resp)=>resp.json())
    .then((data)=>{
      setdata_prodcut(data);
    })
      }catch(error){
        console.log("server is down");
      }
    }

    fetch_data();  

  },[])
  return (
        <div className="pop">
            <h1>POPULAR IN WOMEN</h1>
            <hr />
            <div className="pop-item">
                {data_product.map((item,i)=>{
                    return <Item key={i} id={item.id} name={item.name} image={item.image} new_price={item.new_price} old_price={item.old_price}/>
                })}
            </div>
        </div>
  )
}

export default Popular
